import { Checkbox } from '@zoopla-eng/zds-components/checkbox';
import { Stack } from '@zoopla-eng/zds-components/stack';

export type BuyerIncentive = '' | 'help_to_buy';
export type ChainFree = 'true' | '';
export type ReducedPrice = 'true' | '';
export type IncludeSold = 'true' | '';

export type PropertyStatus = {
    buyerIncentive: BuyerIncentive;
    chainFree: ChainFree;
    reducedPrice: ReducedPrice;
    includeSold: IncludeSold;
};

type PropertyStatusProps = {
    value: PropertyStatus;
    onChange: (propertyStatus: PropertyStatus) => void;
};

export const PropertyStatus = ({ value, onChange }: PropertyStatusProps) => {
    return (
        <Stack
            flexDirection="row"
            flexWrap="wrap"
            columnGap="0"
            rowGap="$S400"
            items={{
                width: '100%',
                '@M100': {
                    width: '50%'
                }
            }}
        >
            <Checkbox
                name="buyer_incentive"
                label="Help to buy"
                checked={value.buyerIncentive === 'help_to_buy'}
                onCheckedChange={(checked) => {
                    onChange({
                        ...value,
                        buyerIncentive: checked ? 'help_to_buy' : ''
                    });
                }}
            />
            <Checkbox
                name="chain_free"
                label="Chain-free"
                checked={value.chainFree === 'true'}
                onCheckedChange={(checked) => {
                    onChange({
                        ...value,
                        chainFree: checked ? 'true' : ''
                    });
                }}
            />
            <Checkbox
                name="reduced_price"
                label="Price-reduced"
                checked={value.reducedPrice === 'true'}
                onCheckedChange={(checked) => {
                    onChange({
                        ...value,
                        reducedPrice: checked ? 'true' : ''
                    });
                }}
            />
            <Checkbox
                name="include_sold"
                label="Under offer/Sold STC"
                checked={value.includeSold === 'true'}
                onCheckedChange={(checked) => {
                    onChange({
                        ...value,
                        includeSold: checked ? 'true' : ''
                    });
                }}
            />
        </Stack>
    );
};
